import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Gallery } from '@pages/Gallery';
import { Home } from '@pages/Home';
import GalleryList from '@pages/GalleryList/GalleryList';
import { GalleryIDEnum } from '@models/gallery-list';
import { OneCatalog } from '@pages/OneCatalog';
import { Taro } from '@pages/Taro';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<GalleryList />} />
        <Route path="/gallery/:galleryId" element={<Gallery />} />
        <Route path="/my-works" element={<Gallery id={GalleryIDEnum.MY_WORKS} />} />
        <Route path="/one-catalog" element={<OneCatalog />} />
        <Route path="/taro" element={<Taro />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
